import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
const ModalContent = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "464px",
  borderRadius: "8px",
  background: "#fff",
  padding: "32px 28px",
  "@media (max-width: 600px)": {
    width: "312px",
    padding: "24px",
    borderRadius: "28px",
    fontFamily: "Inter, sans-serif",
  },
});

const ModalClose = styled("a")({
  width: "24px",
  height: "24px",
  position: "absolute",
  top: "20px",
  right: "20px",
  cursor: "pointer",
  color: "#aaa",
  "@media (max-width: 600px)": {
    display: "none",
  },
});

interface IProps {
  open: boolean;
  handCancel?: VoidFunction;
  handConfirm?: VoidFunction;
}
export default function TurnOffWebsiteModal({
  open,
  handCancel,
  handConfirm,
}: IProps) {
  return (
    <Modal open={open} onClose={handCancel}>
      <ModalContent>
        <ModalClose>
          <CloseIcon onClick={handCancel}></CloseIcon>
        </ModalClose>
        <Typography
          sx={{
            fontSize: "18px",
            lineHeight: "28px",
            color: "error.main",
            fontWeight: 700,
            "@media (max-width: 600px)": {
              fontSize: "24px",
              lineHeight: "32px",
              fontWeight: "400",
              color: "#111315",
              fontFamily: "Inter, sans-serif",
            },
          }}
          variant="h6"
        >
          Tắt website
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "24px",
            color: "#111",
            marginTop: "8px",
            "@media (max-width: 600px)": {
              marginTop: "16px",
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: "400",
              color: "#919AA4",
              fontFamily: "Inter, sans-serif",
            },
          }}
        >
          Website của bạn sẽ ngừng hoạt động. Bạn có chắc chắn muốn tắt website
          bán hàng không?
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "38px",
            "@media (max-width: 600px)": {
              marginTop: "28px",
            },
          }}
        >
          <Button
            variant="contained"
            sx={(theme) => ({
              padding: "7px 31px",
              fontSize: "14px",
              lineHeight: "18px",
              background: theme.palette.error.main,
              color: "#fff",
              fontWeight: 700,
              "&:hover": {
                background: theme.palette.error.dark,
              },
              "@media (max-width: 600px)": {
                padding: "10px",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                fontFamily: "Inter,sans-serif",
                color: "#DD3730",
                borderRadius: "12px",
                background: "#fff",
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                  background: "rgba(11, 107, 255, 0.04)",
                },
              },
            })}
            onClick={handConfirm}
          >
            Đồng ý
          </Button>
          <Button
            variant="contained"
            sx={(theme) => ({
              padding: "7px 31px",
              fontSize: "14px",
              lineHeight: "18px",
              background: theme.palette.neutral.main,
              marginLeft: "16px",
              fontWeight: 700,
              "&:hover": {
                background: theme.palette.neutral.dark,
              },
              "@media (max-width: 600px)": {
                boxShadow: "none",
                padding: "10px 24px",
                borderRadius: "12px",
                background: "#0070F4",
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                fontFamily: "Inter,sans-serif",
                marginLeft: "8px",
                "&:hover,&:focus": {
                  backgroundColor: "#004881",
                  boxShadow: "none",
                },
              },
            })}
            onClick={handCancel}
          >
            Bỏ qua
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
}
